/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sign-in-container[_ngcontent-%COMP%]{height:100vh;display:grid;justify-items:center;align-items:center}.sign-in-card[_ngcontent-%COMP%]{width:400px;height:320px;padding:32px}.nested-grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr;row-gap:1em}.card-actions[_ngcontent-%COMP%]{padding:8px}"];
export { styles as styles };
